import axios from './interceptor'
import { baseUrl } from './config'

export default {
  async get (merchantId) {
    const res = await axios.get(`${baseUrl}/c/merchant/${merchantId}`)
    return res.data
  },
  async getTimeslot (merchantId) {
    const res = await axios.get(`${baseUrl}/c/merchant/${merchantId}/timeslots`)
    return res.data
  },
  async link () {
    const res = await axios.get(`${baseUrl}/m/merchant/link`)
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/merchant.js